import { BaseModel } from '@tcc-mono/shared/data-access';

export class Avatar extends BaseModel {
  id: string;
  image?: string;
  content: string;
  name: string;
}
